import { useEffect, useState } from "react";
import { Alert, Divider, Stack } from "@mui/material";
import TablaDesarrollo from "./TablaDesarrollo.jsx";
import Card from "react-bootstrap/Card";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import { sql } from "../componentes/api.js";
import Anexos from "./Anexos.jsx";

const ProyectoActividad = (props) => {
  const [cargando, setCargando] = useState(false);
  const [archivoAnexo, setArchivoAnexo] = useState("");
  const [idActividad, setIdActividad] = useState("");
  const [idProyectoActividad, setIdProyectoActividad] = useState();
  const [actividadesProyecto, setActividadesProyecto] = useState([]);
  const [requiereAnexo, setRequiereAnexo] = useState(0);

  useEffect(() => {
    cargarProyectoActividad(0);
  }, []);

  const cargarProyectoActividad = async (filtro) => {
    try {
      setCargando(true);
      const response = await sql("getProyectoActividad", "POST", {
        idProyecto: props.idProyecto,
        tipoParticipante: props.tipoParticipante,
        idCargo: "",
        filtro: filtro,
      });
      setActividadesProyecto(response);
      setCargando(false);
    } catch (error) {
      setCargando(false);
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar las Actividades del Proyecto",
        error,
      ]);
    }
  };

  const filtrar = (event) => {
    event.preventDefault();
    cargarProyectoActividad(event.target.value);
  };

  return (
    <div className="container-fluid">
      <div className="row mt-3 mb-3">
        <Stack
          spacing={{ xs: 1, sm: 2 }}
          direction="row"
          useFlexGap
          sx={{ flexWrap: "wrap" }}
        >
          <Alert severity="success">
            <strong>ACTIVIDADES DEL PROYECTO</strong>
            <br />
            <div
              className="btn-group"
              role="group"
              aria-label="Basic mixed styles example"
            >
              <button
                type="button"
                className="btn btn-dark"
                value={0}
                onClick={filtrar}
              >
                Todos
              </button>
              <button
                type="button"
                className="btn btn-danger"
                value={1}
                onClick={filtrar}
              >
                Pendientes
              </button>
              <button
                type="button"
                className="btn btn-warning"
                value={2}
                onClick={filtrar}
              >
                Para Revisión
              </button>
              <button
                type="button"
                className="btn btn-success"
                value={3}
                onClick={filtrar}
              >
                Devueltas
              </button>
              <button
                type="button"
                className="btn btn-primary"
                value={4}
                onClick={filtrar}
              >
                Con Visto Bueno
              </button>
            </div>
            {cargando === true && (
              <div className="spinner-grow text-primary" role="status"></div>
            )}
          </Alert>
        </Stack>
      </div>

      {/* {actividadesProyecto.toString().length > 0 && actividadesProyecto.map((reg, i)=>{ */}
      {actividadesProyecto.map((reg, i) => {
        return (
          <div className="row mb-3" key={i}>
            <Card className="card shadow mb-3">
              <Card.Body>
                <Card.Title>
                  {i + 1}. {reg.Nbre}
                </Card.Title>
                {/* <Card.Subtitle className="mb-2 text-muted">{reg.TipoProyecto}</Card.Subtitle> */}

                <Card.Subtitle className="mb-2 text-muted mb-3 mt-3">
                  <CalendarMonthIcon /> Actividad para realizarse desde el{" "}
                  {reg.FechaIni.toString().substring(0, 10)} al{" "}
                  {reg.FechaFin.toString().substring(0, 10)}
                  <p className="mt-0 mb-0">
                    Tiene anexos guías: {reg.TieneAnexos === 1 ? "Si" : "No"}
                  </p>
                  <p className="mt-0 mb-0">
                    Anexos requeridos mensuales: {reg.AnexosRequeridosMes}
                  </p>
                  <p className="mt-0 mb-0">
                    Anexos requeridos en total: {reg.AnexosRequeridosTotal}
                  </p>
                </Card.Subtitle>

                {/* Zona para mirar los anexos de guías */}
                {reg.TieneAnexos === 1 && (
                  <blockquote className="blockquote mb-0">
                    <p>
                      {" "}
                      <EmojiObjectsIcon /> Esta actividad contiene los
                      suguientes archivos guías{" "}
                    </p>
                    <Anexos
                      Proyecto={props.idProyecto}
                      Actividad={reg.IdActividad}
                      llamador={props.llamador}
                    />
                  </blockquote>
                )}

                <Divider className="mb-3 mt-3" />
                {/* zona para adjuntar los anexos requeridos */}
                {reg.AnexosRequeridosMes > 0 ? (
                  <div className="row mt-3">
                    {/* {mostrarTabla(reg.Id, reg.AnexosRequeridosTotal)} */}
                    <TablaDesarrollo
                      idProyectoActividad={reg.Id}
                      idParticipante={props.idUsuario}
                      anexosRequeridos={reg.AnexosRequeridosTotal}
                      llamador={props.llamador}
                      mostrarMsg={props.mostrarMsg}
                    />
                  </div>
                ) : (
                  <Alert severity="success">
                    No requiere anexar archivos para esta Actividad!
                  </Alert>
                )}
              </Card.Body>
            </Card>
          </div>
        );
      })}

      {/* <VerAnexoDoc
        setVerAnexos={setVerAnexos}
        ruta={
          props.llamador === "Proyectos"
            ? "proyectos/actividades"
            : props.llamador === "Asesores"
            ? "asesores/actividades"
            : "beneficiarios/actividades"
        }
        archivo={archivoAnexo}
        tipoAnexo={tipoAnexo}
      /> */}

      {/* <VerAnexo
        verAnexos={verAnexos}
        handleClose={handleClose1}
        idProyecto={props.idProyecto}
        idActividad={idActividad}
        idProyectoActividad={idProyectoActividad}
        requiereAnexo={requiereAnexo}
        idUsuario={props.idUsuario}
        carpeta={
          props.llamador === "Proyectos"
            ? "proyectos/actividades"
            : props.llamador === "Asesores"
            ? "asesores/actividades"
            : "beneficiarios/actividades"
        }
      /> */}
    </div>
  );
};

export default ProyectoActividad;
